import { useCallback, useEffect, useState } from "react"
import { exportProject as exportProjectToJSON } from "../domains/projects/actions/export"
import { Project } from "domains/wordcloudplus/domains/database/db"
import { useDb } from "domains/wordcloudplus/domains/database/database"

interface Props {
    afterLoad?: (projects: Project[]) => void
}

export const useProjects = ({ afterLoad }: Props) => {
    const [projects, setProjects] = useState<Project[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<Error | null>(null)
    const { db } = useDb()

    const loadData = useCallback(() => {
        if (db == null) return
        setLoading(true)
        db.projects
            .toArray()
            .then((projects) => {
                setProjects(projects)
                afterLoad?.(projects)
            })
            .catch(setError)
            .finally(() => {
                setLoading(false)
            })
    }, [afterLoad, db])

    const exportProjects = useCallback(
        (ids: number[]) => {
            if (db == null) return
            const projectsToExport = projects.filter((project) => project.id !== undefined && ids.includes(project.id))
            projectsToExport.forEach((project) => {
                exportProjectToJSON(project)
            })
        },
        [db, projects]
    )

    useEffect(() => {
        loadData()
    }, [loadData])

    const reload = () => {
        loadData()
    }

    return { projects, loading, error, reload, exportProjects }
}
